<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getPerformanceTiming } from "./utils/auth.js"

export default {
  name: "App",
  components: {
  },
  props: {
    keys: {
      type: String,
      default: "zh_CN"
    }
  },
  created() {
    // this.$store.dispatch("user/getInfo");
    // const obj = getPerformanceTiming()
    // 获取快速编码表
    // this.$store.dispatch("sysCodeData/getSysDataCodeList");
  }
};
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
